import { gql } from '@apollo/client'

export const GET_ALL_REPORTS = gql`
  query GetAllReports(
    $searchQuery: String
    $limit: Int
    $offset: Int
    $filtersReports: filtersReports
    $ids: [Int]
    $notIds: [Int]
    $onlySearchFolio: Boolean
    $statusIds: [Int]
  ) {
    getAllReports(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
      filtersReports: $filtersReports
      ids: $ids
      notIds: $notIds
      onlySearchFolio: $onlySearchFolio
      statusIds: $statusIds
    ) {
      rows {
        id
        user_id
        ReportCitizenOfUsers {
          name
        }
        status_id
        description
        folio
        start_date
        due_date
        planning_date
        jurisdiction_id
        channel_capture
        sub_jurisdiction_id
        group_id
        priority
        ReportToGroup {
          name
        }
        group_category_id
        ReportToGroupCategory {
          name
          icon
        }
        group_category_sub_id
        ReportToGroupCategorySub {
          name
          icon
        }
        completed_at
        ReportToUsers {
          type_user
          name
          phone
          address
          suspended
        }
        StatusOfReport {
          id
          name
          description
          progress
          color
          order
        }
        JurisdictionOfReport {
          name
        }
        JurisdictionsSubOfReport {
          name
        }
        currentReportAndReportsRelated {
          currentReport {
            id
            folio
            isOriginal
            isDuplicated
          }
          reportsRelated {
            id
            folio
            isOriginal
            isDuplicated
          }
        }
        UserTlajoChatOfReport {
          id
          name
          phone
          from
        }
        colony_id
        ColonyOfReport {
          name
          nocolonia
        }
        isOriginal
        isDuplicated
        zone_id
      }
      count
    }
  }
`

export const GET_REPORTS_AVAILABLE = gql`
  query GetReportsAvailable(
    $searchQuery: String
    $limit: Int
    $offset: Int
    $notIds: [Int!]
    $group_id: Int
    $group_category_id: Int
    $group_category_sub_id: Int
    $zone_id: Int
    $colony_id: Int
  ) {
    getReportsAvailable(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
      notIds: $notIds
      group_id: $group_id
      group_category_id: $group_category_id
      group_category_sub_id: $group_category_sub_id
      zone_id: $zone_id
      colony_id: $colony_id
    ) {
      rows {
        id
        user_id
        status_id
        description
        folio
        start_date
        due_date
        planning_date
        jurisdiction_id
        channel_capture
        sub_jurisdiction_id
        group_id
        priority
        ReportToGroup {
          name
        }
        group_category_id
        ReportToGroupCategory {
          name
          icon
        }
        group_category_sub_id
        ReportToGroupCategorySub {
          name
          icon
        }
        completed_at
        ReportToUsers {
          type_user
          name
        }
        StatusOfReport {
          id
          name
        }
        JurisdictionOfReport {
          name
        }
        JurisdictionsSubOfReport {
          name
        }
        UserTlajoChatOfReport {
          id
          name
          phone
          from
        }
      }
      count
    }
  }
`

export const GET_ONE_REPORT_BY_ID = gql`
  query GetOneReportById($reportId: Int!) {
    getOneReportById(reportId: $reportId) {
      id
      user_id
      ReportCitizenOfUsers {
        id
        name
        phone
        address
      }
      status_id
      description
      start_date
      due_date
      planning_date
      jurisdiction_id
      sub_jurisdiction_id
      group_id
      group_category_id
      priority
      ReportToGroupCategory {
        name
        icon
      }
      group_category_sub_id
      ReportToGroupCategorySub {
        name
        icon
      }
      completed_at
      email_notification
      push_notification
      evaluation
      data_form_json
      folio
      channel_capture
      responsible_id
      citizen_send_date
      zone_id
      ReportsToResponsible {
        id
        name
        email
        JobPositionOfUser {
          name
        }
        address
      }
      ReportToUsers {
        id
        type_user
        name
        first_name
        last_name
        email
        phone
        avatarKey
        avatarUrl
        id_role
        address
      }
      StatusOfReport {
        id
        name
        description
        progress
        color
        order
      }
      JurisdictionOfReport {
        name
      }
      JurisdictionsSubOfReport {
        name
      }
      AttachmentsOfReport {
        id
        user_id
        url
        type_file
        UserOfReportAttachment {
          name
          id_role
          RoleOfUser {
            role_name
          }
        }
      }
      ObservationsOfReport {
        id
        user_id
        content
        UserOfReportObservation {
          name
        }
      }
      AddressOfReport {
        id
        report_id
        street
        zipcode
        state
        city
        reference
        latitude
        longitude
        address_full
        url_google_map
      }
      isOriginal
      isDuplicated
      UserTlajoChatOfReport {
        id
        name
        phone
        from
      }
      colony_id
      ColonyOfReport {
        name
        nocolonia
      }
      currentReportAndReportsRelated {
        currentReport {
          id
          folio
          isOriginal
          isDuplicated
        }
        reportsRelated {
          id
          folio
          isOriginal
          isDuplicated
        }
      }
      UserRegisterOfReport {
        id
        name
        first_name
        last_name
        email
      }
    }
  }
`

export const GET_CURRENT_REPORT_AND_REPORTS_RELATED = gql`
  query GetCurrentReportAndReportsRelated($reportId: Int!) {
    getCurrentReportAndReportsRelated(reportId: $reportId) {
      currentReport {
        id
        folio
        isOriginal
        isDuplicated
      }
      reportsRelated {
        id
        folio
        isOriginal
        isDuplicated
      }
    }
  }
`

export const UPDATE_REPORT = gql`
  mutation UpdateReport($reportId: Int!, $input: inputEditReport!) {
    updateReport(reportId: $reportId, input: $input)
  }
`

export const DELETE_REPORT_RELATED = gql`
  mutation DeleteReportRelated($reportId: Int!) {
    deleteReportRelated(reportId: $reportId)
  }
`

export const CHANGE_REPORT_STATUS = gql`
  mutation ChangeReportStatus($input: inputChangeReportStatus!) {
    changeReportStatus(input: $input)
  }
`
export const ACTIVATE_NOTIFICATIONS_REPORT = gql`
  mutation ActivateNotificationReport(
    $reportId: Int!
    $typeNotifications: String!
    $isActive: Boolean
  ) {
    activateNotificationReport(
      reportId: $reportId
      typeNotifications: $typeNotifications
      isActive: $isActive
    )
  }
`
export const GET_REPORTS_BY_USER = gql`
  query GetReportsByUserId($userId: Int!, $limit: Int, $offset: Int) {
    getReportsByUserId(userId: $userId, limit: $limit, offset: $offset) {
      count
      rows {
        id
        due_date
        folio
        description
        completed_at
        start_date
        user_id
        planning_date
        data_form_json
        group_id
        channel_capture
        ReportToGroup {
          name
        }
        group_category_id
        ReportToGroupCategory {
          name
          icon
        }
        group_category_sub_id
        ReportToGroupCategorySub {
          name
          icon
        }
        StatusOfReport {
          name
          type
          id
        }
      }
    }
  }
`

export const GET_REQUIRE_ATTENTION_REPORTS = gql`
  query GetRequireAttentionReports($limit: Int, $statusIds: [Int]) {
    getRequireAttentionReports(limit: $limit, statusIds: $statusIds) {
      id
      channel_capture
      folio
      start_date
      ReportsToResponsible {
        id
        name
      }
      ReportCitizenOfUsers {
        id
        name
      }
      ReportToUsers {
        id
        name
      }
      UserTlajoChatOfReport {
        id
        name
      }
      StatusOfReport {
        id
        name
      }
    }
  }
`

export const CREATE_REPORT_FROM_WEB = gql`
  mutation ReportCreationFromWeb($input: inputReportCreationFromWeb!) {
    reportCreationFromWeb(input: $input)
  }
`

export const CHANGE_REPORT_STATUS_MODAL = gql`
  mutation ChangeReportStatusV2($input: inputChangeReportStatusV2!) {
    changeReportStatusV2(input: $input)
  }
`

export const GET_ALL_RESPONSIBLES_BY_REPORT_ID = gql`
  mutation GetAllResponsiblesByReportId($reportId: Int!) {
    getAllResponsiblesByReportId(reportId: $reportId) {
      id
      name
      charge
      JobPositionOfUser {
        name
      }
    }
  }
`

export const DUPLICATED_REPORTS = gql`
  mutation DuplicatedReports($reportId: Int!, $duplicatedReports: [Int!]!) {
    duplicatedReports(
      reportId: $reportId
      duplicatedReports: $duplicatedReports
    )
  }
`
export const EXPORT_REPORTS = gql`
  mutation ExportReports(
    $dateFrom: String
    $dateTo: String
    $statusIds: [Int]
    $subcategoriesIds: [Int]
    $zonesIds: [Int]
  ) {
    exportReports(
      dateFrom: $dateFrom
      dateTo: $dateTo
      statusIds: $statusIds
      subcategoriesIds: $subcategoriesIds
      zonesIds: $zonesIds
    ) {
      id
      folio
      start_date
      channel_capture
      group_category_id
      data_form_json
      ReportToGroupCategory {
        name
        icon
      }
      group_category_sub_id
      ReportToGroupCategorySub {
        name
        icon
      }
      ReportToUsers {
        type_user
        name
        phone
      }
      StatusOfReport {
        id
        name
        description
        progress
        color
        order
      }
      JurisdictionsSubOfReport {
        name
      }
      AddressOfReport {
        id
        latitude
        longitude
        reference
        state
        street
        url_google_map
        zipcode
        address_full
        city
      }
      ReportCitizenOfUsers {
        id
        name
        phone
      }
      UserTlajoChatOfReport {
        id
        name
        phone
      }
    }
  }
`
export const UPDATE_PRIORITY_REPORT = gql`
  mutation UpdatePriorityReport($id: Int!, $priority: String!) {
    updatePriorityReport(reportId: $id, priority: $priority)
  }
`

export const GET_ALL_REPORTS_FLAT = gql`
  query GetAllReportsFlat($filters: filtersReportsFlat) {
    getAllReportsFlat(filters: $filters) {
      id
      status_id
      zone_id
      AddressOfReport {
        latitude
        longitude
      }
    }
  }
`
